export default {
 "columns": 77,
 "image": "back-cave-tiles.png",
 "imageheight": 685,
 "imagewidth": 1232,
 "margin": 0,
 "name": "back-cave-tiles",
 "spacing": 0,
 "tilecount": 3234,
 "tiledversion": "1.11.2",
 "tileheight": 16,
 "tilewidth": 16,
 "type": "tileset",
 "version": "1.10",
 "tiles": [
  {
   "id": 162,
   "type": "decal"
  },
  {
   "id": 172,
   "type": "decal"
  },
  {
   "id": 173,
   "type": "decal"
  },
  {
   "id": 174,
   "type": "decal"
  },
  {
   "id": 178,
   "type": "decal"
  },
  {
   "id": 179,
   "type": "decal"
  },
  {
   "id": 180,
   "type": "decal"
  },
  {
   "id": 183,
   "type": "decal"
  },
  {
   "id": 184,
   "type": "decal"
  },
  {
   "id": 185,
   "type": "decal"
  },
  {
   "id": 188,
   "type": "decal"
  },
  {
   "id": 189,
   "type": "decal"
  },
  {
   "id": 190,
   "type": "decal"
  },
  {
   "id": 191,
   "type": "decal"
  },
  {
   "id": 194,
   "type": "decal"
  },
  {
   "id": 195,
   "type": "decal"
  },
  {
   "id": 196,
   "type": "decal"
  },
  {
   "id": 197,
   "type": "decal"
  },
  {
   "id": 200,
   "type": "decal"
  },
  {
   "id": 201,
   "type": "decal"
  },
  {
   "id": 204,
   "type": "decal"
  },
  {
   "id": 205,
   "type": "decal"
  },
  {
   "id": 206,
   "type": "decal"
  },
  {
   "id": 207,
   "type": "decal"
  },
  {
   "id": 208,
   "type": "decal"
  },
  {
   "id": 212,
   "type": "decal"
  },
  {
   "id": 213,
   "type": "decal"
  },
  {
   "id": 214,
   "type": "decal"
  },
  {
   "id": 215,
   "type": "decal"
  },
  {
   "id": 216,
   "type": "decal"
  },
  {
   "id": 219,
   "type": "decal"
  },
  {
   "id": 220,
   "type": "decal"
  },
  {
   "id": 221,
   "type": "decal"
  },
  {
   "id": 239,
   "type": "decal"
  },
  {
   "id": 249,
   "type": "decal"
  },
  {
   "id": 250,
   "type": "decal"
  },
  {
   "id": 251,
   "type": "decal"
  },
  {
   "id": 255,
   "type": "decal"
  },
  {
   "id": 256,
   "type": "decal"
  },
  {
   "id": 257,
   "type": "decal"
  },
  {
   "id": 260,
   "type": "decal"
  },
  {
   "id": 261,
   "type": "decal"
  },
  {
   "id": 262,
   "type": "decal"
  },
  {
   "id": 265,
   "type": "decal"
  },
  {
   "id": 266,
   "type": "decal"
  },
  {
   "id": 267,
   "type": "decal"
  },
  {
   "id": 268,
   "type": "decal"
  },
  {
   "id": 271,
   "type": "decal"
  },
  {
   "id": 272,
   "type": "decal"
  },
  {
   "id": 273,
   "type": "decal"
  },
  {
   "id": 274,
   "type": "decal"
  },
  {
   "id": 277,
   "type": "decal"
  },
  {
   "id": 278,
   "type": "decal"
  },
  {
   "id": 281,
   "type": "decal"
  },
  {
   "id": 282,
   "type": "decal"
  },
  {
   "id": 283,
   "type": "decal"
  },
  {
   "id": 284,
   "type": "decal"
  },
  {
   "id": 285,
   "type": "decal"
  },
  {
   "id": 289,
   "type": "decal"
  },
  {
   "id": 290,
   "type": "decal"
  },
  {
   "id": 291,
   "type": "decal"
  },
  {
   "id": 292,
   "type": "decal"
  },
  {
   "id": 293,
   "type": "decal"
  },
  {
   "id": 296,
   "type": "decal"
  },
  {
   "id": 297,
   "type": "decal"
  },
  {
   "id": 298,
   "type": "decal"
  },
  {
   "id": 311,
   "type": "decal"
  },
  {
   "id": 313,
   "type": "decal"
  },
  {
   "id": 314,
   "type": "decal"
  },
  {
   "id": 316,
   "type": "decal"
  },
  {
   "id": 321,
   "type": "decal"
  },
  {
   "id": 322,
   "type": "decal"
  },
  {
   "id": 323,
   "type": "decal"
  },
  {
   "id": 326,
   "type": "decal"
  },
  {
   "id": 327,
   "type": "decal"
  },
  {
   "id": 328,
   "type": "decal"
  },
  {
   "id": 332,
   "type": "decal"
  },
  {
   "id": 333,
   "type": "decal"
  },
  {
   "id": 334,
   "type": "decal"
  },
  {
   "id": 335,
   "type": "decal"
  },
  {
   "id": 337,
   "type": "decal"
  },
  {
   "id": 338,
   "type": "decal"
  },
  {
   "id": 339,
   "type": "decal"
  },
  {
   "id": 342,
   "type": "decal"
  },
  {
   "id": 343,
   "type": "decal"
  },
  {
   "id": 344,
   "type": "decal"
  },
  {
   "id": 345,
   "type": "decal"
  },
  {
   "id": 348,
   "type": "decal"
  },
  {
   "id": 349,
   "type": "decal"
  },
  {
   "id": 350,
   "type": "decal"
  },
  {
   "id": 351,
   "type": "decal"
  },
  {
   "id": 354,
   "type": "decal"
  },
  {
   "id": 355,
   "type": "decal"
  },
  {
   "id": 358,
   "type": "decal"
  },
  {
   "id": 359,
   "type": "decal"
  },
  {
   "id": 360,
   "type": "decal"
  },
  {
   "id": 361,
   "type": "decal"
  },
  {
   "id": 362,
   "type": "decal"
  },
  {
   "id": 366,
   "type": "decal"
  },
  {
   "id": 367,
   "type": "decal"
  },
  {
   "id": 368,
   "type": "decal"
  },
  {
   "id": 369,
   "type": "decal"
  },
  {
   "id": 370,
   "type": "decal"
  },
  {
   "id": 374,
   "type": "decal"
  },
  {
   "id": 375,
   "type": "decal"
  },
  {
   "id": 387,
   "type": "decal"
  },
  {
   "id": 388,
   "type": "decal"
  },
  {
   "id": 390,
   "type": "decal"
  },
  {
   "id": 391,
   "type": "decal"
  },
  {
   "id": 393,
   "type": "decal"
  },
  {
   "id": 398,
   "type": "decal"
  },
  {
   "id": 399,
   "type": "decal"
  },
  {
   "id": 400,
   "type": "decal"
  },
  {
   "id": 403,
   "type": "decal"
  },
  {
   "id": 404,
   "type": "decal"
  },
  {
   "id": 405,
   "type": "decal"
  },
  {
   "id": 409,
   "type": "decal"
  },
  {
   "id": 410,
   "type": "decal"
  },
  {
   "id": 411,
   "type": "decal"
  },
  {
   "id": 414,
   "type": "decal"
  },
  {
   "id": 415,
   "type": "decal"
  },
  {
   "id": 416,
   "type": "decal"
  },
  {
   "id": 419,
   "type": "decal"
  },
  {
   "id": 420,
   "type": "decal"
  },
  {
   "id": 421,
   "type": "decal"
  },
  {
   "id": 425,
   "type": "decal"
  },
  {
   "id": 426,
   "type": "decal"
  },
  {
   "id": 427,
   "type": "decal"
  },
  {
   "id": 428,
   "type": "decal"
  },
  {
   "id": 431,
   "type": "decal"
  },
  {
   "id": 432,
   "type": "decal"
  },
  {
   "id": 435,
   "type": "decal"
  },
  {
   "id": 436,
   "type": "decal"
  },
  {
   "id": 437,
   "type": "decal"
  },
  {
   "id": 438,
   "type": "decal"
  },
  {
   "id": 439,
   "type": "decal"
  },
  {
   "id": 445,
   "type": "decal"
  },
  {
   "id": 446,
   "type": "decal"
  },
  {
   "id": 451,
   "type": "decal"
  },
  {
   "id": 452,
   "type": "decal"
  },
  {
   "id": 464,
   "type": "decal"
  },
  {
   "id": 465,
   "type": "decal"
  },
  {
   "id": 467,
   "type": "decal"
  },
  {
   "id": 468,
   "type": "decal"
  },
  {
   "id": 470,
   "type": "decal"
  },
  {
   "id": 480,
   "type": "decal"
  },
  {
   "id": 481,
   "type": "decal"
  },
  {
   "id": 482,
   "type": "decal"
  },
  {
   "id": 486,
   "type": "decal"
  },
  {
   "id": 487,
   "type": "decal"
  },
  {
   "id": 488,
   "type": "decal"
  },
  {
   "id": 541,
   "type": "decal"
  },
  {
   "id": 542,
   "type": "decal"
  },
  {
   "id": 618,
   "type": "decal"
  },
  {
   "id": 619,
   "type": "decal"
  },
  {
   "id": 722,
   "type": "decal"
  },
  {
   "id": 723,
   "type": "decal"
  },
  {
   "id": 724,
   "type": "decal"
  },
  {
   "id": 727,
   "type": "decal"
  },
  {
   "id": 728,
   "type": "decal"
  },
  {
   "id": 729,
   "type": "decal"
  },
  {
   "id": 733,
   "type": "decal"
  },
  {
   "id": 734,
   "type": "decal"
  },
  {
   "id": 735,
   "type": "decal"
  },
  {
   "id": 736,
   "type": "decal"
  },
  {
   "id": 739,
   "type": "decal"
  },
  {
   "id": 740,
   "type": "decal"
  },
  {
   "id": 743,
   "type": "decal"
  },
  {
   "id": 744,
   "type": "decal"
  },
  {
   "id": 745,
   "type": "decal"
  },
  {
   "id": 746,
   "type": "decal"
  },
  {
   "id": 747,
   "type": "decal"
  },
  {
   "id": 752,
   "type": "decal"
  },
  {
   "id": 753,
   "type": "decal"
  },
  {
   "id": 759,
   "type": "decal"
  },
  {
   "id": 760,
   "type": "decal"
  },
  {
   "id": 772,
   "type": "decal"
  },
  {
   "id": 773,
   "type": "decal"
  },
  {
   "id": 799,
   "type": "decal"
  },
  {
   "id": 800,
   "type": "decal"
  },
  {
   "id": 801,
   "type": "decal"
  },
  {
   "id": 804,
   "type": "decal"
  },
  {
   "id": 805,
   "type": "decal"
  },
  {
   "id": 806,
   "type": "decal"
  },
  {
   "id": 807,
   "type": "decal"
  },
  {
   "id": 810,
   "type": "decal"
  },
  {
   "id": 811,
   "type": "decal"
  },
  {
   "id": 812,
   "type": "decal"
  },
  {
   "id": 813,
   "type": "decal"
  },
  {
   "id": 816,
   "type": "decal"
  },
  {
   "id": 817,
   "type": "decal"
  },
  {
   "id": 820,
   "type": "decal"
  },
  {
   "id": 821,
   "type": "decal"
  },
  {
   "id": 822,
   "type": "decal"
  },
  {
   "id": 823,
   "type": "decal"
  },
  {
   "id": 824,
   "type": "decal"
  },
  {
   "id": 828,
   "type": "decal"
  },
  {
   "id": 829,
   "type": "decal"
  },
  {
   "id": 830,
   "type": "decal"
  },
  {
   "id": 831,
   "type": "decal"
  },
  {
   "id": 832,
   "type": "decal"
  },
  {
   "id": 836,
   "type": "decal"
  },
  {
   "id": 837,
   "type": "decal"
  },
  {
   "id": 849,
   "type": "decal"
  },
  {
   "id": 850,
   "type": "decal"
  },
  {
   "id": 876,
   "type": "decal"
  },
  {
   "id": 877,
   "type": "decal"
  },
  {
   "id": 878,
   "type": "decal"
  },
  {
   "id": 881,
   "type": "decal"
  },
  {
   "id": 882,
   "type": "decal"
  },
  {
   "id": 883,
   "type": "decal"
  },
  {
   "id": 884,
   "type": "decal"
  },
  {
   "id": 887,
   "type": "decal"
  },
  {
   "id": 888,
   "type": "decal"
  },
  {
   "id": 889,
   "type": "decal"
  },
  {
   "id": 890,
   "type": "decal"
  },
  {
   "id": 893,
   "type": "decal"
  },
  {
   "id": 894,
   "type": "decal"
  },
  {
   "id": 897,
   "type": "decal"
  },
  {
   "id": 898,
   "type": "decal"
  },
  {
   "id": 899,
   "type": "decal"
  },
  {
   "id": 900,
   "type": "decal"
  },
  {
   "id": 901,
   "type": "decal"
  },
  {
   "id": 905,
   "type": "decal"
  },
  {
   "id": 906,
   "type": "decal"
  },
  {
   "id": 907,
   "type": "decal"
  },
  {
   "id": 908,
   "type": "decal"
  },
  {
   "id": 909,
   "type": "decal"
  },
  {
   "id": 913,
   "type": "decal"
  },
  {
   "id": 914,
   "type": "decal"
  },
  {
   "id": 915,
   "type": "decal"
  },
  {
   "id": 953,
   "type": "decal"
  },
  {
   "id": 954,
   "type": "decal"
  },
  {
   "id": 955,
   "type": "decal"
  },
  {
   "id": 958,
   "type": "decal"
  },
  {
   "id": 959,
   "type": "decal"
  },
  {
   "id": 960,
   "type": "decal"
  },
  {
   "id": 961,
   "type": "decal"
  },
  {
   "id": 964,
   "type": "decal"
  },
  {
   "id": 965,
   "type": "decal"
  },
  {
   "id": 966,
   "type": "decal"
  },
  {
   "id": 967,
   "type": "decal"
  },
  {
   "id": 970,
   "type": "decal"
  },
  {
   "id": 971,
   "type": "decal"
  },
  {
   "id": 974,
   "type": "decal"
  },
  {
   "id": 975,
   "type": "decal"
  },
  {
   "id": 976,
   "type": "decal"
  },
  {
   "id": 977,
   "type": "decal"
  },
  {
   "id": 978,
   "type": "decal"
  },
  {
   "id": 982,
   "type": "decal"
  },
  {
   "id": 983,
   "type": "decal"
  },
  {
   "id": 984,
   "type": "decal"
  },
  {
   "id": 985,
   "type": "decal"
  },
  {
   "id": 986,
   "type": "decal"
  },
  {
   "id": 990,
   "type": "decal"
  },
  {
   "id": 991,
   "type": "decal"
  },
  {
   "id": 992,
   "type": "decal"
  },
  {
   "id": 1047,
   "type": "decal"
  },
  {
   "id": 1048,
   "type": "decal"
  },
  {
   "id": 1394,
   "type": "decal"
  },
  {
   "id": 1404,
   "type": "decal"
  },
  {
   "id": 1405,
   "type": "decal"
  },
  {
   "id": 1406,
   "type": "decal"
  },
  {
   "id": 1410,
   "type": "decal"
  },
  {
   "id": 1411,
   "type": "decal"
  },
  {
   "id": 1412,
   "type": "decal"
  },
  {
   "id": 1415,
   "type": "decal"
  },
  {
   "id": 1416,
   "type": "decal"
  },
  {
   "id": 1417,
   "type": "decal"
  },
  {
   "id": 1420,
   "type": "decal"
  },
  {
   "id": 1421,
   "type": "decal"
  },
  {
   "id": 1422,
   "type": "decal"
  },
  {
   "id": 1423,
   "type": "decal"
  },
  {
   "id": 1426,
   "type": "decal"
  },
  {
   "id": 1427,
   "type": "decal"
  },
  {
   "id": 1428,
   "type": "decal"
  },
  {
   "id": 1429,
   "type": "decal"
  },
  {
   "id": 1432,
   "type": "decal"
  },
  {
   "id": 1433,
   "type": "decal"
  },
  {
   "id": 1436,
   "type": "decal"
  },
  {
   "id": 1437,
   "type": "decal"
  },
  {
   "id": 1438,
   "type": "decal"
  },
  {
   "id": 1439,
   "type": "decal"
  },
  {
   "id": 1440,
   "type": "decal"
  },
  {
   "id": 1444,
   "type": "decal"
  },
  {
   "id": 1445,
   "type": "decal"
  },
  {
   "id": 1446,
   "type": "decal"
  },
  {
   "id": 1447,
   "type": "decal"
  },
  {
   "id": 1448,
   "type": "decal"
  },
  {
   "id": 1451,
   "type": "decal"
  },
  {
   "id": 1452,
   "type": "decal"
  },
  {
   "id": 1453,
   "type": "decal"
  },
  {
   "id": 1456,
   "type": "decal"
  },
  {
   "id": 1457,
   "type": "decal"
  },
  {
   "id": 1458,
   "type": "decal"
  },
  {
   "id": 1466,
   "type": "decal"
  },
  {
   "id": 1469,
   "type": "decal"
  },
  {
   "id": 1471,
   "type": "decal"
  },
  {
   "id": 1476,
   "type": "decal"
  },
  {
   "id": 1477,
   "type": "decal"
  },
  {
   "id": 1478,
   "type": "decal"
  },
  {
   "id": 1481,
   "type": "decal"
  },
  {
   "id": 1482,
   "type": "decal"
  },
  {
   "id": 1483,
   "type": "decal"
  },
  {
   "id": 1487,
   "type": "decal"
  },
  {
   "id": 1488,
   "type": "decal"
  },
  {
   "id": 1489,
   "type": "decal"
  },
  {
   "id": 1492,
   "type": "decal"
  },
  {
   "id": 1493,
   "type": "decal"
  },
  {
   "id": 1494,
   "type": "decal"
  },
  {
   "id": 1497,
   "type": "decal"
  },
  {
   "id": 1498,
   "type": "decal"
  },
  {
   "id": 1499,
   "type": "decal"
  },
  {
   "id": 1500,
   "type": "decal"
  },
  {
   "id": 1503,
   "type": "decal"
  },
  {
   "id": 1504,
   "type": "decal"
  },
  {
   "id": 1505,
   "type": "decal"
  },
  {
   "id": 1506,
   "type": "decal"
  },
  {
   "id": 1509,
   "type": "decal"
  },
  {
   "id": 1510,
   "type": "decal"
  },
  {
   "id": 1513,
   "type": "decal"
  },
  {
   "id": 1514,
   "type": "decal"
  },
  {
   "id": 1515,
   "type": "decal"
  },
  {
   "id": 1516,
   "type": "decal"
  },
  {
   "id": 1517,
   "type": "decal"
  },
  {
   "id": 1521,
   "type": "decal"
  },
  {
   "id": 1522,
   "type": "decal"
  },
  {
   "id": 1523,
   "type": "decal"
  },
  {
   "id": 1524,
   "type": "decal"
  },
  {
   "id": 1525,
   "type": "decal"
  },
  {
   "id": 1528,
   "type": "decal"
  },
  {
   "id": 1529,
   "type": "decal"
  },
  {
   "id": 1530,
   "type": "decal"
  },
  {
   "id": 1533,
   "type": "decal"
  },
  {
   "id": 1534,
   "type": "decal"
  },
  {
   "id": 1535,
   "type": "decal"
  },
  {
   "id": 1536,
   "type": "decal"
  },
  {
   "id": 1543,
   "type": "decal"
  },
  {
   "id": 1545,
   "type": "decal"
  },
  {
   "id": 1546,
   "type": "decal"
  },
  {
   "id": 1548,
   "type": "decal"
  },
  {
   "id": 1553,
   "type": "decal"
  },
  {
   "id": 1554,
   "type": "decal"
  },
  {
   "id": 1555,
   "type": "decal"
  },
  {
   "id": 1558,
   "type": "decal"
  },
  {
   "id": 1559,
   "type": "decal"
  },
  {
   "id": 1560,
   "type": "decal"
  },
  {
   "id": 1564,
   "type": "decal"
  },
  {
   "id": 1565,
   "type": "decal"
  },
  {
   "id": 1566,
   "type": "decal"
  },
  {
   "id": 1567,
   "type": "decal"
  },
  {
   "id": 1569,
   "type": "decal"
  },
  {
   "id": 1570,
   "type": "decal"
  },
  {
   "id": 1571,
   "type": "decal"
  },
  {
   "id": 1574,
   "type": "decal"
  },
  {
   "id": 1575,
   "type": "decal"
  },
  {
   "id": 1576,
   "type": "decal"
  },
  {
   "id": 1577,
   "type": "decal"
  },
  {
   "id": 1580,
   "type": "decal"
  },
  {
   "id": 1581,
   "type": "decal"
  },
  {
   "id": 1582,
   "type": "decal"
  },
  {
   "id": 1583,
   "type": "decal"
  },
  {
   "id": 1586,
   "type": "decal"
  },
  {
   "id": 1587,
   "type": "decal"
  },
  {
   "id": 1590,
   "type": "decal"
  },
  {
   "id": 1591,
   "type": "decal"
  },
  {
   "id": 1592,
   "type": "decal"
  },
  {
   "id": 1593,
   "type": "decal"
  },
  {
   "id": 1594,
   "type": "decal"
  },
  {
   "id": 1598,
   "type": "decal"
  },
  {
   "id": 1599,
   "type": "decal"
  },
  {
   "id": 1600,
   "type": "decal"
  },
  {
   "id": 1601,
   "type": "decal"
  },
  {
   "id": 1602,
   "type": "decal"
  },
  {
   "id": 1606,
   "type": "decal"
  },
  {
   "id": 1607,
   "type": "decal"
  },
  {
   "id": 1610,
   "type": "decal"
  },
  {
   "id": 1611,
   "type": "decal"
  },
  {
   "id": 1612,
   "type": "decal"
  },
  {
   "id": 1613,
   "type": "decal"
  },
  {
   "id": 1619,
   "type": "decal"
  },
  {
   "id": 1620,
   "type": "decal"
  },
  {
   "id": 1622,
   "type": "decal"
  },
  {
   "id": 1623,
   "type": "decal"
  },
  {
   "id": 1625,
   "type": "decal"
  },
  {
   "id": 1635,
   "type": "decal"
  },
  {
   "id": 1636,
   "type": "decal"
  },
  {
   "id": 1637,
   "type": "decal"
  },
  {
   "id": 1641,
   "type": "decal"
  },
  {
   "id": 1642,
   "type": "decal"
  },
  {
   "id": 1643,
   "type": "decal"
  },
  {
   "id": 1646,
   "type": "decal"
  },
  {
   "id": 1647,
   "type": "decal"
  },
  {
   "id": 1648,
   "type": "decal"
  },
  {
   "id": 1651,
   "type": "decal"
  },
  {
   "id": 1652,
   "type": "decal"
  },
  {
   "id": 1653,
   "type": "decal"
  },
  {
   "id": 1657,
   "type": "decal"
  },
  {
   "id": 1658,
   "type": "decal"
  },
  {
   "id": 1659,
   "type": "decal"
  },
  {
   "id": 1660,
   "type": "decal"
  },
  {
   "id": 1663,
   "type": "decal"
  },
  {
   "id": 1664,
   "type": "decal"
  },
  {
   "id": 1667,
   "type": "decal"
  },
  {
   "id": 1668,
   "type": "decal"
  },
  {
   "id": 1669,
   "type": "decal"
  },
  {
   "id": 1670,
   "type": "decal"
  },
  {
   "id": 1671,
   "type": "decal"
  },
  {
   "id": 1677,
   "type": "decal"
  },
  {
   "id": 1678,
   "type": "decal"
  },
  {
   "id": 1683,
   "type": "decal"
  },
  {
   "id": 1684,
   "type": "decal"
  },
  {
   "id": 1687,
   "type": "decal"
  },
  {
   "id": 1688,
   "type": "decal"
  },
  {
   "id": 1689,
   "type": "decal"
  },
  {
   "id": 1690,
   "type": "decal"
  },
  {
   "id": 1696,
   "type": "decal"
  },
  {
   "id": 1697,
   "type": "decal"
  },
  {
   "id": 1699,
   "type": "decal"
  },
  {
   "id": 1700,
   "type": "decal"
  },
  {
   "id": 1702,
   "type": "decal"
  },
  {
   "id": 1712,
   "type": "decal"
  },
  {
   "id": 1713,
   "type": "decal"
  },
  {
   "id": 1714,
   "type": "decal"
  },
  {
   "id": 1718,
   "type": "decal"
  },
  {
   "id": 1719,
   "type": "decal"
  },
  {
   "id": 1720,
   "type": "decal"
  },
  {
   "id": 1765,
   "type": "decal"
  },
  {
   "id": 1766,
   "type": "decal"
  },
  {
   "id": 1767,
   "type": "decal"
  },
  {
   "id": 1773,
   "type": "decal"
  },
  {
   "id": 1774,
   "type": "decal"
  },
  {
   "id": 1850,
   "type": "decal"
  },
  {
   "id": 1851,
   "type": "decal"
  },
  {
   "id": 1954,
   "type": "decal"
  },
  {
   "id": 1955,
   "type": "decal"
  },
  {
   "id": 1956,
   "type": "decal"
  },
  {
   "id": 1959,
   "type": "decal"
  },
  {
   "id": 1960,
   "type": "decal"
  },
  {
   "id": 1961,
   "type": "decal"
  },
  {
   "id": 1965,
   "type": "decal"
  },
  {
   "id": 1966,
   "type": "decal"
  },
  {
   "id": 1967,
   "type": "decal"
  },
  {
   "id": 1968,
   "type": "decal"
  },
  {
   "id": 1971,
   "type": "decal"
  },
  {
   "id": 1972,
   "type": "decal"
  },
  {
   "id": 1975,
   "type": "decal"
  },
  {
   "id": 1976,
   "type": "decal"
  },
  {
   "id": 1977,
   "type": "decal"
  },
  {
   "id": 1978,
   "type": "decal"
  },
  {
   "id": 1979,
   "type": "decal"
  },
  {
   "id": 1984,
   "type": "decal"
  },
  {
   "id": 1985,
   "type": "decal"
  },
  {
   "id": 1991,
   "type": "decal"
  },
  {
   "id": 1992,
   "type": "decal"
  },
  {
   "id": 1995,
   "type": "decal"
  },
  {
   "id": 1996,
   "type": "decal"
  },
  {
   "id": 1997,
   "type": "decal"
  },
  {
   "id": 2031,
   "type": "decal"
  },
  {
   "id": 2032,
   "type": "decal"
  },
  {
   "id": 2033,
   "type": "decal"
  },
  {
   "id": 2036,
   "type": "decal"
  },
  {
   "id": 2037,
   "type": "decal"
  },
  {
   "id": 2038,
   "type": "decal"
  },
  {
   "id": 2039,
   "type": "decal"
  },
  {
   "id": 2042,
   "type": "decal"
  },
  {
   "id": 2043,
   "type": "decal"
  },
  {
   "id": 2044,
   "type": "decal"
  },
  {
   "id": 2045,
   "type": "decal"
  },
  {
   "id": 2048,
   "type": "decal"
  },
  {
   "id": 2049,
   "type": "decal"
  },
  {
   "id": 2052,
   "type": "decal"
  },
  {
   "id": 2053,
   "type": "decal"
  },
  {
   "id": 2054,
   "type": "decal"
  },
  {
   "id": 2055,
   "type": "decal"
  },
  {
   "id": 2056,
   "type": "decal"
  },
  {
   "id": 2060,
   "type": "decal"
  },
  {
   "id": 2061,
   "type": "decal"
  },
  {
   "id": 2062,
   "type": "decal"
  },
  {
   "id": 2063,
   "type": "decal"
  },
  {
   "id": 2064,
   "type": "decal"
  },
  {
   "id": 2068,
   "type": "decal"
  },
  {
   "id": 2069,
   "type": "decal"
  },
  {
   "id": 2072,
   "type": "decal"
  },
  {
   "id": 2073,
   "type": "decal"
  },
  {
   "id": 2074,
   "type": "decal"
  },
  {
   "id": 2075,
   "type": "decal"
  },
  {
   "id": 2108,
   "type": "decal"
  },
  {
   "id": 2109,
   "type": "decal"
  },
  {
   "id": 2110,
   "type": "decal"
  },
  {
   "id": 2113,
   "type": "decal"
  },
  {
   "id": 2114,
   "type": "decal"
  },
  {
   "id": 2115,
   "type": "decal"
  },
  {
   "id": 2116,
   "type": "decal"
  },
  {
   "id": 2119,
   "type": "decal"
  },
  {
   "id": 2120,
   "type": "decal"
  },
  {
   "id": 2121,
   "type": "decal"
  },
  {
   "id": 2122,
   "type": "decal"
  },
  {
   "id": 2125,
   "type": "decal"
  },
  {
   "id": 2126,
   "type": "decal"
  },
  {
   "id": 2129,
   "type": "decal"
  },
  {
   "id": 2130,
   "type": "decal"
  },
  {
   "id": 2131,
   "type": "decal"
  },
  {
   "id": 2132,
   "type": "decal"
  },
  {
   "id": 2133,
   "type": "decal"
  },
  {
   "id": 2137,
   "type": "decal"
  },
  {
   "id": 2138,
   "type": "decal"
  },
  {
   "id": 2139,
   "type": "decal"
  },
  {
   "id": 2140,
   "type": "decal"
  },
  {
   "id": 2141,
   "type": "decal"
  },
  {
   "id": 2145,
   "type": "decal"
  },
  {
   "id": 2146,
   "type": "decal"
  },
  {
   "id": 2147,
   "type": "decal"
  },
  {
   "id": 2149,
   "type": "decal"
  },
  {
   "id": 2150,
   "type": "decal"
  },
  {
   "id": 2151,
   "type": "decal"
  },
  {
   "id": 2152,
   "type": "decal"
  },
  {
   "id": 2185,
   "type": "decal"
  },
  {
   "id": 2186,
   "type": "decal"
  },
  {
   "id": 2187,
   "type": "decal"
  },
  {
   "id": 2190,
   "type": "decal"
  },
  {
   "id": 2191,
   "type": "decal"
  },
  {
   "id": 2192,
   "type": "decal"
  },
  {
   "id": 2193,
   "type": "decal"
  },
  {
   "id": 2196,
   "type": "decal"
  },
  {
   "id": 2197,
   "type": "decal"
  },
  {
   "id": 2198,
   "type": "decal"
  },
  {
   "id": 2199,
   "type": "decal"
  },
  {
   "id": 2202,
   "type": "decal"
  },
  {
   "id": 2203,
   "type": "decal"
  },
  {
   "id": 2206,
   "type": "decal"
  },
  {
   "id": 2207,
   "type": "decal"
  },
  {
   "id": 2208,
   "type": "decal"
  },
  {
   "id": 2209,
   "type": "decal"
  },
  {
   "id": 2210,
   "type": "decal"
  },
  {
   "id": 2214,
   "type": "decal"
  },
  {
   "id": 2215,
   "type": "decal"
  },
  {
   "id": 2216,
   "type": "decal"
  },
  {
   "id": 2217,
   "type": "decal"
  },
  {
   "id": 2218,
   "type": "decal"
  },
  {
   "id": 2222,
   "type": "decal"
  },
  {
   "id": 2223,
   "type": "decal"
  },
  {
   "id": 2224,
   "type": "decal"
  },
  {
   "id": 2226,
   "type": "decal"
  },
  {
   "id": 2227,
   "type": "decal"
  },
  {
   "id": 2228,
   "type": "decal"
  },
  {
   "id": 2229,
   "type": "decal"
  },
  {
   "id": 2304,
   "type": "decal"
  },
  {
   "id": 2305,
   "type": "decal"
  },
  {
   "id": 2306,
   "type": "decal"
  },
  {
   "id": 2594,
   "type": "decal"
  },
  {
   "id": 2595,
   "type": "decal"
  },
  {
   "id": 2596,
   "type": "decal"
  },
  {
   "id": 2597,
   "type": "decal"
  },
  {
   "id": 2600,
   "type": "decal"
  },
  {
   "id": 2601,
   "type": "decal"
  },
  {
   "id": 2602,
   "type": "decal"
  },
  {
   "id": 2603,
   "type": "decal"
  },
  {
   "id": 2655,
   "type": "decal"
  },
  {
   "id": 2656,
   "type": "decal"
  },
  {
   "id": 2657,
   "type": "decal"
  },
  {
   "id": 2658,
   "type": "decal"
  },
  {
   "id": 2659,
   "type": "decal"
  },
  {
   "id": 2660,
   "type": "decal"
  },
  {
   "id": 2663,
   "type": "decal"
  },
  {
   "id": 2664,
   "type": "decal"
  },
  {
   "id": 2665,
   "type": "decal"
  },
  {
   "id": 2666,
   "type": "decal"
  },
  {
   "id": 2667,
   "type": "decal"
  },
  {
   "id": 2668,
   "type": "decal"
  },
  {
   "id": 2671,
   "type": "decal"
  },
  {
   "id": 2672,
   "type": "decal"
  },
  {
   "id": 2673,
   "type": "decal"
  },
  {
   "id": 2674,
   "type": "decal"
  },
  {
   "id": 2677,
   "type": "decal"
  },
  {
   "id": 2678,
   "type": "decal"
  },
  {
   "id": 2679,
   "type": "decal"
  },
  {
   "id": 2680,
   "type": "decal"
  },
  {
   "id": 2710,
   "type": "decal"
  },
  {
   "id": 2716,
   "type": "decal"
  },
  {
   "id": 2717,
   "type": "decal"
  },
  {
   "id": 2719,
   "type": "decal"
  },
  {
   "id": 2723,
   "type": "decal"
  },
  {
   "id": 2724,
   "type": "decal"
  },
  {
   "id": 2725,
   "type": "decal"
  },
  {
   "id": 2727,
   "type": "decal"
  },
  {
   "id": 2728,
   "type": "decal"
  },
  {
   "id": 2729,
   "type": "decal"
  },
  {
   "id": 2732,
   "type": "decal"
  },
  {
   "id": 2733,
   "type": "decal"
  },
  {
   "id": 2734,
   "type": "decal"
  },
  {
   "id": 2735,
   "type": "decal"
  },
  {
   "id": 2736,
   "type": "decal"
  },
  {
   "id": 2737,
   "type": "decal"
  },
  {
   "id": 2740,
   "type": "decal"
  },
  {
   "id": 2741,
   "type": "decal"
  },
  {
   "id": 2742,
   "type": "decal"
  },
  {
   "id": 2743,
   "type": "decal"
  },
  {
   "id": 2744,
   "type": "decal"
  },
  {
   "id": 2745,
   "type": "decal"
  },
  {
   "id": 2748,
   "type": "decal"
  },
  {
   "id": 2749,
   "type": "decal"
  },
  {
   "id": 2750,
   "type": "decal"
  },
  {
   "id": 2751,
   "type": "decal"
  },
  {
   "id": 2754,
   "type": "decal"
  },
  {
   "id": 2755,
   "type": "decal"
  },
  {
   "id": 2756,
   "type": "decal"
  },
  {
   "id": 2757,
   "type": "decal"
  },
  {
   "id": 2777,
   "type": "decal"
  },
  {
   "id": 2778,
   "type": "decal"
  },
  {
   "id": 2780,
   "type": "decal"
  },
  {
   "id": 2781,
   "type": "decal"
  },
  {
   "id": 2783,
   "type": "decal"
  },
  {
   "id": 2784,
   "type": "decal"
  },
  {
   "id": 2786,
   "type": "decal"
  },
  {
   "id": 2787,
   "type": "decal"
  },
  {
   "id": 2789,
   "type": "decal"
  },
  {
   "id": 2790,
   "type": "decal"
  },
  {
   "id": 2791,
   "type": "decal"
  },
  {
   "id": 2793,
   "type": "decal"
  },
  {
   "id": 2794,
   "type": "decal"
  },
  {
   "id": 2796,
   "type": "decal"
  },
  {
   "id": 2797,
   "type": "decal"
  },
  {
   "id": 2800,
   "type": "decal"
  },
  {
   "id": 2801,
   "type": "decal"
  },
  {
   "id": 2802,
   "type": "decal"
  },
  {
   "id": 2804,
   "type": "decal"
  },
  {
   "id": 2805,
   "type": "decal"
  },
  {
   "id": 2806,
   "type": "decal"
  },
  {
   "id": 2809,
   "type": "decal"
  },
  {
   "id": 2810,
   "type": "decal"
  },
  {
   "id": 2811,
   "type": "decal"
  },
  {
   "id": 2812,
   "type": "decal"
  },
  {
   "id": 2813,
   "type": "decal"
  },
  {
   "id": 2814,
   "type": "decal"
  },
  {
   "id": 2817,
   "type": "decal"
  },
  {
   "id": 2818,
   "type": "decal"
  },
  {
   "id": 2819,
   "type": "decal"
  },
  {
   "id": 2820,
   "type": "decal"
  },
  {
   "id": 2821,
   "type": "decal"
  },
  {
   "id": 2822,
   "type": "decal"
  },
  {
   "id": 2825,
   "type": "decal"
  },
  {
   "id": 2826,
   "type": "decal"
  },
  {
   "id": 2827,
   "type": "decal"
  },
  {
   "id": 2828,
   "type": "decal"
  },
  {
   "id": 2831,
   "type": "decal"
  },
  {
   "id": 2832,
   "type": "decal"
  },
  {
   "id": 2833,
   "type": "decal"
  },
  {
   "id": 2834,
   "type": "decal"
  },
  {
   "id": 2877,
   "type": "decal"
  },
  {
   "id": 2878,
   "type": "decal"
  },
  {
   "id": 2879,
   "type": "decal"
  },
  {
   "id": 2881,
   "type": "decal"
  },
  {
   "id": 2882,
   "type": "decal"
  },
  {
   "id": 2883,
   "type": "decal"
  },
  {
   "id": 2886,
   "type": "decal"
  },
  {
   "id": 2887,
   "type": "decal"
  },
  {
   "id": 2888,
   "type": "decal"
  },
  {
   "id": 2889,
   "type": "decal"
  },
  {
   "id": 2890,
   "type": "decal"
  },
  {
   "id": 2891,
   "type": "decal"
  },
  {
   "id": 2894,
   "type": "decal"
  },
  {
   "id": 2895,
   "type": "decal"
  },
  {
   "id": 2896,
   "type": "decal"
  },
  {
   "id": 2897,
   "type": "decal"
  },
  {
   "id": 2898,
   "type": "decal"
  },
  {
   "id": 2899,
   "type": "decal"
  },
  {
   "id": 2902,
   "type": "decal"
  },
  {
   "id": 2903,
   "type": "decal"
  },
  {
   "id": 2904,
   "type": "decal"
  },
  {
   "id": 2905,
   "type": "decal"
  },
  {
   "id": 2908,
   "type": "decal"
  },
  {
   "id": 2909,
   "type": "decal"
  },
  {
   "id": 2910,
   "type": "decal"
  },
  {
   "id": 2911,
   "type": "decal"
  },
  {
   "id": 2954,
   "type": "decal"
  },
  {
   "id": 2955,
   "type": "decal"
  },
  {
   "id": 2956,
   "type": "decal"
  },
  {
   "id": 2958,
   "type": "decal"
  },
  {
   "id": 2959,
   "type": "decal"
  },
  {
   "id": 2960,
   "type": "decal"
  },
  {
   "id": 2963,
   "type": "decal"
  },
  {
   "id": 2964,
   "type": "decal"
  },
  {
   "id": 2965,
   "type": "decal"
  },
  {
   "id": 2966,
   "type": "decal"
  },
  {
   "id": 2967,
   "type": "decal"
  },
  {
   "id": 2968,
   "type": "decal"
  },
  {
   "id": 2971,
   "type": "decal"
  },
  {
   "id": 2972,
   "type": "decal"
  },
  {
   "id": 2973,
   "type": "decal"
  },
  {
   "id": 2974,
   "type": "decal"
  },
  {
   "id": 2975,
   "type": "decal"
  },
  {
   "id": 2976,
   "type": "decal"
  },
  {
   "id": 2979,
   "type": "decal"
  },
  {
   "id": 2980,
   "type": "decal"
  },
  {
   "id": 2981,
   "type": "decal"
  },
  {
   "id": 2982,
   "type": "decal"
  },
  {
   "id": 2985,
   "type": "decal"
  },
  {
   "id": 2986,
   "type": "decal"
  },
  {
   "id": 2987,
   "type": "decal"
  },
  {
   "id": 2988,
   "type": "decal"
  },
  {
   "id": 3040,
   "type": "decal"
  },
  {
   "id": 3041,
   "type": "decal"
  },
  {
   "id": 3042,
   "type": "decal"
  },
  {
   "id": 3043,
   "type": "decal"
  },
  {
   "id": 3044,
   "type": "decal"
  },
  {
   "id": 3045,
   "type": "decal"
  },
  {
   "id": 3048,
   "type": "decal"
  },
  {
   "id": 3049,
   "type": "decal"
  },
  {
   "id": 3050,
   "type": "decal"
  },
  {
   "id": 3051,
   "type": "decal"
  },
  {
   "id": 3052,
   "type": "decal"
  },
  {
   "id": 3053,
   "type": "decal"
  },
  {
   "id": 3056,
   "type": "decal"
  },
  {
   "id": 3057,
   "type": "decal"
  },
  {
   "id": 3058,
   "type": "decal"
  },
  {
   "id": 3059,
   "type": "decal"
  },
  {
   "id": 3062,
   "type": "decal"
  },
  {
   "id": 3063,
   "type": "decal"
  },
  {
   "id": 3064,
   "type": "decal"
  },
  {
   "id": 3065,
   "type": "decal"
  }
 ]
};